import styled from 'styled-components';
import { ApButtonIcon } from '@alixpartners/ui-components';

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const PopoverContent = styled.div`
  display: flex;
  padding: 10px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.25);
`;

export const StyledButtonIcon = styled(ApButtonIcon)`
  &:not(:first-child) {
    margin-left: 5px;
  }
`;
